import { jsPDF } from "jspdf";

export const generateCertificatePdf = async ({
  name,
  position,
  organization,
}: {
  name: string;
  position: string;
  organization: string;
}) => {
  const doc = new jsPDF({
    orientation: "landscape",
    unit: "px",
    format: "a4",
  });

  const width = doc.internal.pageSize.getWidth();
  const height = doc.internal.pageSize.getHeight();

  // Load background image
  const bgImage = new Image();
  bgImage.src = "/images/certificate_bg.png"; // from public folder

  await new Promise((resolve, reject) => {
    bgImage.onload = resolve;
    bgImage.onerror = reject;
  });

  // Draw background
  doc.addImage(bgImage, "PNG", 0, 0, width, height);

  // === INSERT TEXT (centered block) ===
  const nameY = 200;
  const positionY = 215;
  const orgY = 230;

  doc.setFont("Helvetica", "bold");
  doc.setFontSize(22);
  doc.text(name, width / 2, nameY, { align: "center" });

  doc.setFont("Helvetica", "italic");
  doc.setFontSize(16);
  doc.text(position, width / 2, positionY, { align: "center" });

  doc.text(organization, width / 2, orgY, { align: "center" });

  // Important: return the doc instead of saving it
  return doc;
};
